import axios from "axios";
import * as authTypes from "../../types/admin/authTypes";

import { SHARED_LOGIN_SUCCESS } from "../../types/shared/authTypes";
import api from "../mainAxios/mainAxios";

//Admin-Login
export const adminLoginAction = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.ADMIN_LOGIN_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/signin`,
      { email, password },
      config
    );
    dispatch({
      type: authTypes.ADMIN_LOGIN_SUCCESS,
      payload: data?.data,
    });
    // console.log(data);
    localStorage.setItem("adminInfo", JSON.stringify(data?.data, null, " "));
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.ADMIN_LOGIN_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Logout
export const adminlogoutAction = () => (dispatch) => {
  localStorage.removeItem("sharedUserInfo");
  dispatch({
    type: authTypes.ADMIN_LOGOUT,
  });
};

//Register
export const adminRegisterAction = (formData) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.ADMIN_REGISTER_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/signup`,
      formData,
      config
    );
    // console.log(data);
    const payload = data?.data?.payload;
    dispatch({
      type: authTypes.ADMIN_REGISTER_SUCCESS,
      payload: { payload },
    });
    // localStorage.setItem(
    //   "sharedUserInfo",
    //   JSON.stringify({ payload }, null, " ")
    // );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    console.log({ error });
    dispatch({
      type: authTypes.ADMIN_REGISTER_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Register
export const adminRegisterSuperAction = (formData) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.ADMIN_REGISTER_SUPER_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/new-signup`,
      formData,
      config
    );
    // console.log(data);
    const payload = data?.data?.payload;
    dispatch({
      type: authTypes.ADMIN_REGISTER_SUPER_SUCCESS,
      payload: { payload },
    });

    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
    // localStorage.setItem(
    //   "sharedUserInfo",
    //   JSON.stringify({ payload }, null, " ")
    // );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.ADMIN_REGISTER_SUPER_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
//UpdateDetail
export const adminUpdateDetailAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: authTypes.ADMIN_UPDATE_DETAIL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/detail/${sharedUserInfo?.payload?.id}`,
        formData,
        config
      );
      dispatch({
        type: authTypes.ADMIN_UPDATE_DETAIL_SUCCESS,
        payload: data?.data,
      });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data?.payload?.token, null, " ")
      );
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: authTypes.ADMIN_UPDATE_DETAIL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//ChangePassword
export const adminChangePasswordAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: authTypes.ADMIN_CHANGE_PASSWORD_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/changepassword/${sharedUserInfo?.payload?.id}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: authTypes.ADMIN_CHANGE_PASSWORD_SUCCESS,
        payload: data?.data?.payload?.token,
      });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data, null, " ")
      );
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: authTypes.ADMIN_CHANGE_PASSWORD_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//ChangedImage
export const adminChangedImageAction =
  (selectedFile) => async (dispatch, getState) => {
    try {
      dispatch({
        type: authTypes.ADMIN_UPDATE_IMAGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const formData = new FormData();

      formData.append("profileImage", selectedFile);
      // console.log(formData);
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/updateimage/${sharedUserInfo?.payload?.id}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: authTypes.ADMIN_UPDATE_IMAGE_SUCCESS,
        payload: data?.data,
      });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data?.payload?.token, null, " ")
      );
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: authTypes.ADMIN_UPDATE_IMAGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Resend Email
export const userResendEmailAction = (email) => async (dispatch, getState) => {
  try {
    dispatch({
      type: authTypes.ADMIN_RESEND_EMAIL_REQUEST,
    });
    let body = {
      email,
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/resendemail`,
      body
    );
    dispatch({
      type: authTypes.ADMIN_RESEND_EMAIL_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.ADMIN_RESEND_EMAIL_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Onboard Complete
export const adminOnboardAction = (onBoard) => async (dispatch, getState) => {
  try {
    dispatch({
      type: authTypes.ADMIN_ONBOARD_COMPLETE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/setting/onboard`,
      onBoard,
      config
    );
    dispatch({
      type: authTypes.ADMIN_ONBOARD_COMPLETE_SUCCESS,
      payload: data?.data,
    });
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: authTypes.ADMIN_ONBOARD_COMPLETE_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//ChangedImage
export const resendOtpBySMSAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.RESEND_OTP_BY_SMS_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/resend/sms`,
      formdata
    );
    // console.log(data);
    dispatch({
      type: authTypes.RESEND_OTP_BY_SMS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.RESEND_OTP_BY_SMS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Resend Email
export const updateOtpBySmsAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.UPDATE_OPT_BY_SMS_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/update/sms`,
      formdata
    );
    dispatch({
      type: authTypes.UPDATE_OPT_BY_SMS_SUCCESS,
      payload: data?.data,
    });
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    // console.log({ data });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
    localStorage.setItem(
      "browserToken",
      JSON.stringify(data?.data?.payload?.browserToken, null, " ")
    );
    return data?.data?.payload;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: authTypes.UPDATE_OPT_BY_SMS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Resend Email Otp
export const resendOtpByEmailAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.RESEND_OTP_BY_EMAIL_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/resend/email`,
      formdata
    );
    // console.log(data);
    dispatch({
      type: authTypes.RESEND_OTP_BY_EMAIL_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.RESEND_OTP_BY_EMAIL_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Email Otp Update
export const updateOtpByEmailAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.UPDATE_OPT_BY_EMAIL_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/update/email`,
      formdata
    );
    dispatch({
      type: authTypes.UPDATE_OPT_BY_EMAIL_SUCCESS,
      payload: data?.data,
    });
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    // console.log({ data });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
    localStorage.setItem(
      "browserToken",
      JSON.stringify(data?.data?.payload?.browserToken, null, " ")
    );
    return data?.data?.payload;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: authTypes.UPDATE_OPT_BY_EMAIL_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Resend Email
export const tokenRegenerateAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: authTypes.REGENERATE_TOKEN_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/token/regenrate/${sharedUserInfo?.payload?.id}`
    );
    dispatch({
      type: authTypes.REGENERATE_TOKEN_SUCCESS,
      payload: data?.data,
    });
    // console.log({ data });
    const sharedUserInfos = JSON.parse(localStorage.getItem("sharedUserInfo"));
    if (sharedUserInfos?.payload?.token) {
      sharedUserInfos = data?.data?.payload?.token;
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(sharedUserInfos, null, " ")
      );
    }
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: authTypes.REGENERATE_TOKEN_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
//loginUsingToken
export const loginUsingTokenAction = (token) => async (dispatch, getState) => {
  try {
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = {
      token: "Bearer " + token,
    };
    // console.log(formData);
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/token/login`,
      body,
      config
    );
    // console.log(data);
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_SUCCESS,
      payload: data?.data,
    });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_FAIL,
      payload: err,
    });
    // throw Error(err);
  }
};

//loginUsingToken
export const changingTokenAction = (token) => async (dispatch, getState) => {
  try {
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = {
      token: "Bearer " + token,
    };
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/token/change`,
      body,
      config
    );
    // console.log(data);
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_SUCCESS,
      payload: data?.data,
    });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.LOGIN_USING_TOKEN_FAIL,
      payload: err,
    });
    // throw Error(err);
  }
};

export const confirmSignUpOtpBySmsAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/verify-otp-signup`,
      formdata
    );
    dispatch({
      type: authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_SUCCESS,
      payload: data?.data,
    });
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    // console.log({ data });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
    localStorage.setItem(
      "browserToken",
      JSON.stringify(data?.data?.payload?.browserToken, null, " ")
    );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
export const resendSignUpOtpBySMSAction = (formdata) => async (dispatch) => {
  try {
    dispatch({
      type: authTypes.RESEND_SIGN_UP_OTP_BY_SMS_REQUEST,
    });
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/resend-signup-otp`,
      formdata
    );
    // console.log(data);
    dispatch({
      type: authTypes.RESEND_SIGN_UP_OTP_BY_SMS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    // console.log({ error });
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: authTypes.RESEND_SIGN_UP_OTP_BY_SMS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
